/**
 * SVG Start icon for the [RatingWidget] component.
 * Takes a fill value between 0 and 1 to indicate the percentage of the star that should be filled.
 * Its size can be customized using the size prop.
 */
export default function RatingStarIcon({
  fillValue = 1,
  size = '1.5rem',
}: RatingStarIConProps) {
  return (
    <svg
      fill="none"
      height={size}
      viewBox="0 0 23 22"
      width={size}
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        height="22"
        id="star-mask"
        maskUnits="userSpaceOnUse"
        style="mask-type: alpha"
        width="23"
        x="0"
        y="0"
      >
        <path
          d="M10.9227 0.37473C11.1463 -0.124909 11.8537 -0.12491 12.0773 0.374728L14.95 6.79404C15.042 6.99963 15.2359 7.14087 15.4593 7.16509L22.4345 7.92151C22.9774 7.98039 23.196 8.65503 22.7913 9.0227L17.5915 13.7465C17.425 13.8978 17.3509 14.1263 17.397 14.3468L18.8351 21.2336C18.9471 21.7697 18.3749 22.1866 17.9011 21.9142L11.8147 18.4144C11.6198 18.3023 11.3802 18.3023 11.1853 18.4144L5.09888 21.9142C4.62515 22.1866 4.05292 21.7697 4.16486 21.2337L5.603 14.3468C5.64906 14.1263 5.57503 13.8978 5.40849 13.7465L0.208748 9.0227C-0.195967 8.65503 0.022602 7.98039 0.565509 7.92151L7.54073 7.16509C7.76413 7.14087 7.95796 6.99963 8.04996 6.79404L10.9227 0.37473Z"
          fill="#E8EFF7"
        />
      </mask>
      <g mask="url(#star-mask)">
        <path
          d="M10.9227 0.37473C11.1463 -0.124909 11.8537 -0.12491 12.0773 0.374728L14.95 6.79404C15.042 6.99963 15.2359 7.14087 15.4593 7.16509L22.4345 7.92151C22.9774 7.98039 23.196 8.65503 22.7913 9.0227L17.5915 13.7465C17.425 13.8978 17.3509 14.1263 17.397 14.3468L18.8351 21.2336C18.9471 21.7697 18.3749 22.1866 17.9011 21.9142L11.8147 18.4144C11.6198 18.3023 11.3802 18.3023 11.1853 18.4144L5.09888 21.9142C4.62515 22.1866 4.05292 21.7697 4.16486 21.2337L5.603 14.3468C5.64906 14.1263 5.57503 13.8978 5.40849 13.7465L0.208748 9.0227C-0.195967 8.65503 0.022602 7.98039 0.565509 7.92151L7.54073 7.16509C7.76413 7.14087 7.95796 6.99963 8.04996 6.79404L10.9227 0.37473Z"
          fill="#E8EFF7"
        />
        <rect width={23 * fillValue} height="22" fill="#F5D816" />
      </g>
    </svg>
  );
}

export type RatingStarIConProps = {
  fillValue: number;
  size: string;
};
